/* eslint-disable @1js/office-online-rules/no-v8-imports-for-fluentui */
import * as React from "react";

import { useTheme } from "@fluentui/react";

import { AppThemeManager } from "../AppThemeManager";
import type { AppThemeConsumerProps } from "./AppThemeConsumer.types";

export const AppThemeConsumer: React.FunctionComponent<
  AppThemeConsumerProps
> = (props: AppThemeConsumerProps) => {
  const theme = useTheme() || AppThemeManager.getInstance().getTheme();
  return <>{props.children(theme)}</>;
};
